import { render, staticRenderFns } from "./serviceQueueList.vue?vue&type=template&id=29084c29&scoped=true"
import script from "./serviceQueueList.vue?vue&type=script&lang=js"
export * from "./serviceQueueList.vue?vue&type=script&lang=js"
import style0 from "./serviceQueueList.vue?vue&type=style&index=0&id=29084c29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29084c29",
  null
  
)

export default component.exports